module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreating),
      expression: "!isCreating"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.openForm
    }
  }, [_vm._v("\n    Add\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreating),
      expression: "isCreating"
    }],
    staticClass: "segment"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleText),
      expression: "titleText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.titleText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectText),
      expression: "projectText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.projectText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block col-",
    on: {
      "click": function($event) {
        _vm.sendForm()
      }
    }
  }, [_vm._v("\n              Create\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-block",
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("\n              Cancel\n            ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3107a14e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todo-create.vue
// module id = 91
// module chunks = 0